import { CircularGaugeChartProps } from '@doveit/bricks';
import { GoalMetric, PerformanceRating } from '../../../providers/api/dtos';

export const statusColor: Record<PerformanceRating, CircularGaugeChartProps['color']> = ({
  CRITICAL: 'critical',
  BELOW_EXPECTATIONS: 'warning',
  NEARLY_ON_TRACK: 'info',
  ON_TRACK: 'info',
  ABOVE_EXPECTATIONS: 'success',
});

export const metricLabel: Record<GoalMetric, string> = ({
  rumors: 'Notizie',
  prospects: 'Valutazioni',
  assignments: 'Mandati',
  sales: 'Vendite',
});
